import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-flowtrics-bot',
  templateUrl: './flowtrics-bot.component.html',
  styleUrls: ['./flowtrics-bot.component.scss']
})
export class FlowtricsBotComponent implements OnInit {

  postMessageForm = new FormGroup({
    message: new FormControl('')
  })

  constructor() { }
  chatbotToggler: any
  ngOnInit(): void {
    //this.chatbotToggler = document.querySelector(".chatbot-toggler") as HTMLElement;
   }

    


   openCloseBot(){      
      document.body.classList.toggle("show-chatbot");
    }

    postMessage(event){
      if (event.keyCode === 13 || event.eventPhase === 2) {       
        this.postMessageForm.reset();
      }      
    }
//  closeBtn = document.querySelector(".close-btn") as HTMLElement;
//  chatbox = document.querySelector(".chatbox") as HTMLElement;
  chatInput = document.querySelector(".chat-input textarea") as HTMLTextAreaElement;
//  sendChatBtn = document.querySelector(".chat-input span") as HTMLElement;

// userMessage: string | null = null; // Variable to store user's message
//  API_KEY = "PASTE-YOUR-API-KEY"; // Paste your API key here
//  inputInitHeight = this.chatInput.scrollHeight;

 createChatLi = (message: string, className: string): HTMLLIElement => {
    // Create a chat <li> element with passed message and className
    const chatLi = document.createElement("li");
    chatLi.classList.add("chat", `${className}`);
    let chatContent = className === "outgoing" ? `<p></p>` : `<span class="material-symbols-outlined">smart_toy</span><p></p>`;
    chatLi.innerHTML = chatContent;
    chatLi.querySelector("p")!.textContent = message;
    return chatLi; // return chat <li> element
}

// const generateResponse = (chatElement: HTMLElement) => {
//     const API_URL = "https://api.openai.com/v1/chat/completions";
//     const messageElement = chatElement.querySelector("p")!;

//     // Define the properties and message for the API request
//     const requestOptions: RequestInit = {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${API_KEY}`
//         },
//         body: JSON.stringify({
//             model: "gpt-3.5-turbo",
//             messages: [{role: "user", content: this.userMessage}],
//         })
//     }

//     // Send POST request to API, get response and set the reponse as paragraph text
//     fetch(API_URL, requestOptions).then(res => res.json()).then((data: any) => {
//         messageElement.textContent = data.choices[0].message.content.trim();
//     }).catch(() => {
//         messageElement.classList.add("error");
//         messageElement.textContent = "Oops! Something went wrong. Please try again.";
//     }).finally(() => this.chatbox.scrollTo(0, this.chatbox.scrollHeight));
// }

// const handleChat = () => {
//   this.userMessage = this.chatInput.value.trim(); // Get user entered message and remove extra whitespace
//     if(!this.userMessage) return;

//     // Clear the input textarea and set its height to default
//     this.chatInput.value = "";
//     this.chatInput.style.height = `${this.inputInitHeight}px`;

//     // Append the user's message to the chatbox
//     this.chatbox.appendChild(this.createChatLi(this.userMessage, "outgoing"));
//     this.chatbox.scrollTo(0, this.chatbox.scrollHeight);
    
//     setTimeout(() => {
//         // Display "Thinking..." message while waiting for the response
//         const incomingChatLi = this.createChatLi("Thinking...", "incoming");
//         this.chatbox.appendChild(incomingChatLi);
//         this.chatbox.scrollTo(0, this.chatbox.scrollHeight);
//         this.generateResponse(incomingChatLi);
//     }, 600);
// }

// chatInput.addEventListener("input", () => {
//     // Adjust the height of the input textarea based on its content
//     chatInput.style.height = `${inputInitHeight}px`;
//     chatInput.style.height = `${chatInput.scrollHeight}px`;
// });

// chatInput.addEventListener("keydown", (e) => {
//     If Enter key is pressed without Shift key and the window 
//     width is greater than 800px, handle the chat
//     if(e.key === "Enter" && !e.shiftKey && window.innerWidth > 800) {
//         e.preventDefault();
//         this.handleChat();
//     }
// });

// this.sendChatBtn.addEventListener("click", handleChat);
// this.closeBtn.addEventListener("click", () => document.body.classList.remove("show-chatbot"));
 


}
